import axios from 'axios';
export function Profession() {
    return axios.get(process.env.REACT_APP_API + "/api/profession/getall.php");
}
